<template>
  <vx-card title="Bancos">
    
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="bancos"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown
            vs-trigger-click
            class="cursor-pointer mr-4 mb-4"
            v-if="selected.length >= 1"
          >
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="ArchiveIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="SaveIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="$router.push('/bancos/crear')"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Agregar banco</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
      </div>

      <template slot="thead">
        <vs-th>Imagen</vs-th>
        <vs-th sort-key="name">Nombre</vs-th>
        <vs-th sort-key="category">Número de cuenta</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="img-container">
              <img
                :src="tr.imagen.url"
                class="product-img table-product-img"
              />
            </vs-td>

            <vs-td>
              <span>{{ tr.titulo }}</span>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.numero }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="$router.push({name: 'bancos-editar-id', params: {id: tr.id}})"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup
      :title="objectSelected ? objectSelected.titulo : ''"
      :active.sync="modalDelete"
      v-if="objectSelected"
    >
        <section class="text-center">
            <p class="mb-3">¿Está seguro de eliminar?</p>

            <div>
            <vs-button
                class="mr-3"
                color="danger"
                type="flat"
                @click="closeModal()"
                >Cancelar</vs-button
            >
            <vs-button
                color="success"
                type="filled"
                @click.prevent="deleteItem()"
                >{{ loadingAction ? "Eliminando" : "Eliminar" }}</vs-button
            >
            </div>
        </section>
    </vs-popup>
  </vx-card>
</template>

<script>
import GetBancos from '@/apollo/queries/bancos/GetBancos.gql'
import DeleteBancos from "@/apollo/mutations/bancos/DeleteBancos.gql";

export default {
  data() {
    return {
      bancos: [],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      modalDelete: false,
      objectSelected: null,
      loadingAction: false,
      nroTotalItems: 0,
      loading: false,
      number_paginate: 50,
      page: 1,
      showTable: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let number_paginate = this.number_paginate,
          page = this.page

        this.$apollo.query({
          query: GetBancos,
          fetchPolicy: 'no-cache',
          variables: {
            number_paginate,
            page
          }
        })
        .then(res => {
            this.nroTotalItems = res.data.GetBancos.NroItems

            this.bancos = res.data.GetBancos.data
        })
    },
    getStatusColor(status) {
      if (status === 1) return "success";
      if (status === 0) return "warning";
    },
    setTipoEnvio(value) {
      let status;

      if (value == 1) {
        status = "Envío Express";
      } else if (value == 2) {
        status = "Encomienda (Provincias)";
      } else {
        status = "Envío gratuito";
      }

      return status;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(item) {
      this.modalDelete = true;

      this.objectSelected = JSON.parse(JSON.stringify(item));
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    closeModal(type) {
      type === "delete" ? (this.modalDelete = false) : (this.modalEdit = false);

      this.objectSelected = null;
    },
    deleteItem() {
      this.loadingAction = true;

      this.$apollo
        .mutate({
          mutation: DeleteBancos,
          variables: {
            input: {
              id: parseInt(this.objectSelected.id),
            },
          },
        })
        .then(() => {
          this.loadingAction = false;

          this.modalDelete = false;

          this.objectSelected = null;

          this.getData();
        });
    },
  },
  computed: {
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
.table-product-img {
  max-width: 100%;
  width: 80px;
}
</style>